import { List, ListItem, ListItemText, Typography } from '@mui/material'


const ChangesToPolicy = () => {
  return (
    <>
        <Typography variant="h4" fontWeight="bold" gutterBottom>12. Changes to This Policy</Typography>
        <Typography  sx={{ fontSize: '1.1rem' }}>
           We may update this Privacy Policy as our services evolve. Updates will be 
communicated through:
        </Typography>
        <List>
            <ListItem>
                <ListItemText>
                    • In-app notifications or banners
                </ListItemText>
            </ListItem>
             <ListItem>
                <ListItemText>
                   • Updated versions on the Play Store and official website
                </ListItemText>
            </ListItem>
        </List>
        <Typography  sx={{ fontSize: '1.1rem' }}>Continued use of the app after updates constitutes agreement to the revised 
terms.</Typography>

    </>
  )
}

export default ChangesToPolicy